export const USER_SIGNUP_REQUEST = "USER_SIGNUP_REQUEST";
export const USER_SIGNUP_SUCCESS = "USER_SIGNUP_SUCCESS";
export const USER_SIGNUP_FAIL = "USER_SIGNUP_FAIL";
export const USER_SIGNUP_RESET = "USER_SIGNUP_RESET";

export const USER_ADD_NEW_USER_REQUEST = "USER_ADD_NEW_USER_REQUEST";
export const USER_ADD_NEW_USER_SUCCESS = "USER_ADD_NEW_USER_SUCCESS";
export const USER_ADD_NEW_USER_FAIL = "USER_ADD_NEW_USER_FAIL";
export const USER_ADD_NEW_USER_RESET = "USER_ADD_NEW_USER_RESET";

export const USER_SIGNIN_REQUEST = "USER_SIGNIN_REQUEST";
export const USER_SIGNIN_SUCCESS = "USER_SIGNIN_SUCCESS";
export const USER_SIGNIN_FAIL = "USER_SIGNIN_FAIL";
export const USER_SIGNIN_RESET = "USER_SIGNIN_RESET";

export const USER_SIGNOUT = "USER_SIGNOUT";

export const USER_UPDATE_PASSWORD_REQUEST = "USER_UPDATE_PASSWORD_REQUEST";
export const USER_UPDATE_PASSWORD_SUCCESS = "USER_UPDATE_PASSWORD_SUCCESS";
export const USER_UPDATE_PASSWORD_FAIL = "USER_UPDATE_PASSWORD_FAIL";
export const USER_UPDATE_PASSWORD_RESET = "USER_UPDATE_PASSWORD_RESET";

export const USER_EMAIL_VERIFICATION_REQUEST =
  "USER_EMAIL_VERIFICATION_REQUEST";
export const USER_EMAIL_VERIFICATION_SUCCESS =
  "USER_EMAIL_VERIFICATION_SUCCESS";
export const USER_EMAIL_VERIFICATION_ERROR = "USER_EMAIL_VERIFICATION_ERROR";
export const USER_EMAIL_VERIFICATION_RESET = "USER_EMAIL_VERIFICATION_RESET";

export const SEND_EMAIL_TO_RESET_PASSWORD_REQUEST =
  "SEND_EMAIL_TO_RESET_PASSWORD_REQUEST";
export const SEND_EMAIL_TO_RESET_PASSWORD_SUCCESS =
  "SEND_EMAIL_TO_RESET_PASSWORD_SUCCESS";
export const SEND_EMAIL_TO_RESET_PASSWORD_ERROR =
  "SEND_EMAIL_TO_RESET_PASSWORD_ERROR";
export const SEND_EMAIL_TO_RESET_PASSWORD_RESET = "USER_UPDATE_PROFILE_RESET";

export const USER_DELETE_REQUEST = "USER_DELETE_REQUEST";
export const USER_DELETE_SUCCESS = "USER_DELETE_SUCCESS";
export const USER_DELETE_ERROR = "USER_DELETE_ERROR";
export const USER_DELETE_RESET = "USER_DELETE_RESET";

export const USER_LIST_REQUEST = "USER_LIST_REQUEST";
export const USER_LIST_SUCCESS = "USER_LIST_SUCCESS";
export const USER_LIST_ERROR = "USER_LIST_ERROR";
export const USER_LIST_RESET = "USER_LIST_RESET";

export const USER_ALL_LIST_REQUEST = "USER_ALL_LIST_REQUEST";
export const USER_ALL_LIST_SUCCESS = "USER_ALL_LIST_SUCCESS";
export const USER_ALL_LIST_ERROR = "USER_ALL_LIST_ERROR";
export const USER_ALL_LIST_RESET = "USER_ALL_LIST_RESET";

export const ALLY_USER_ROLE = "ally";
export const MASTER_USER_ROLE = "master";

export const USER_ROLE_PRIMARY = "primary";
export const USER_ROLE_SECONDARY = "secondary";

export const SEND_EMAIL_FOR_CONFIRMATION_REQUEST =
  "SEND_EMAIL_FOR_CONFIRMATION_REQUEST";
export const SEND_EMAIL_FOR_CONFIRMATION_SUCCESS =
  "SEND_EMAIL_FOR_CONFIRMATION_SUCCESS";
export const SEND_EMAIL_FOR_CONFIRMATION_ERROR =
  "SEND_EMAIL_FOR_CONFIRMATION_ERROR";
export const SEND_EMAIL_FOR_CONFIRMATION_RESET =
  "SEND_EMAIL_FOR_CONFIRMATION_RESET";

export const SEND_EMAIL_FOR_VENDOR_CONFIRMATION_REQUEST =
  "SEND_EMAIL_FOR_VENDOR_CONFIRMATION_REQUEST";
export const SEND_EMAIL_FOR_VENDOR_CONFIRMATION_SUCCESS =
  "SEND_EMAIL_FOR_VENDOR_CONFIRMATION_SUCCESS";
export const SEND_EMAIL_FOR_VENDOR_CONFIRMATION_ERROR =
  "SEND_EMAIL_FOR_VENDOR_CONFIRMATION_ERROR";
export const SEND_EMAIL_FOR_VENDOR_CONFIRMATION_RESET =
  "SEND_EMAIL_FOR_VENDOR_CONFIRMATION_RESET";

export const UPDATE_USER_PROFILE_REQUEST = "UPDATE_USER_PROFILE_REQUEST";
export const UPDATE_USER_PROFILE_ERROR = "UPDATE_USER_PROFILE_ERROR";
export const UPDATE_USER_PROFILE_SUCCESS = "UPDATE_USER_PROFILE_SUCCESS";
export const UPDATE_USER_PROFILE_RESET = "UPDATE_USER_PROFILE_RESET";

export const CHANGE_PASSWORD_REQUEST = "CHANGE_PASSWORD_REQUEST";
export const CHANGE_PASSWORD_ERROR = "CHANGE_PASSWORD_ERROR";
export const CHANGE_PASSWORD_SUCCESS = "CHANGE_PASSWORD_SUCCESS";
export const CHANGE_PASSWORD_RESET = "CHANGE_PASSWORD_RESET";

export const CAMPAIGN_PLANNER = "campaignPlanner";
export const CAMPAIGN_MANAGER = "campaignManager";
export const SCREEN_ADMIN = "screenAdmin";
export const SCREEN_OWNER = "screenOwner";
export const SCREEN_MANAGER = "screenManager";
export const CLIENT_POC_USER = "clientPocUser";
export const PROOH_ADMIN = "screenAdmin";

export const CAMPAIGN_STATUS_CHANGED_TO_ACTIVE_PLANNING_PAGE =
  "campaignStatusChangedToActivePLanningPage";
export const CAMPAIGN_STATUS_CHANGED_TO_PAUSED_PLANNING_PAGE =
  "campaignStatusChangedToPausedPlanningPage";
export const CAMPAIGN_STATUS_CHANGED_TO_DELETED_PLANNING_PAGE =
  "campaignStatusChangedToDeletedPlanningPage";
export const CAMPAIGN_CHANGE_DATE_AND_CREATIVE_PLANNING_PAGE =
  "campaignChangeDateAndCreativePlanningPage";

export const USERS_GET_PLANNING_PAGE = "usersGetPlanningPage";
export const USERS_DELETE_PLANNING_PAGE = "usersDeletePlanningPage";
export const USERS_ADD_PLANNING_PAGE = "usersAddPlanningPage";

export const CREATIVE_GET_PLANNING_PAGE = "creativeGetPlanningPage";
export const CREATIVE_ADD_PLANNING_PAGE = "creativeAddPlanningPage";

export const CAMPAIGN_CREATION_EDIT_END_DATE_PLANNING_PAGE =
  "campaignCreationEditEndDatePlanningPage";
export const CAMPAIGN_CREATION_GET_ALL_CAMPAIGN_DATA_PLANNING_PAGE =
  "campaignCreationGetAllCampaignDataPlanningPage";
export const CAMPAIGN_CREATION_GET_CAMPAIGN_DETAILS_PLANNING_PAGE =
  "campaignCreationGetCampaignDetailsPlanningPage";
export const CAMPAIGN_CREATION_CREATE_CLONE_PLANNING_PAGE =
  "campaignCreationCreateClonePlanningPage";

export const CAMPAIGN_CREATION_ADD_DETAILS_TO_CREATE_CAMPAIGN_PLANNING_PAGE =
  "campaignCreationAddDetailsToCreateCampaignPlanningPage";
export const CAMPAIGN_STATUS_PLEA_REQUEST_FINAL_APPROVAL_SENT =
  "PleaRequestFinalApprovalSent";
export const CAMPAIGN_STATUS_PLEA_REQUEST_FINAL_APPROVAL_ACCEPTED =
  "PleaRequestFinalApprovalAccepted";
export const CAMPAIGN_STATUS_PLEA_REQUEST_FINAL_APPROVAL_REJECTED =
  "PleaRequestFinalApprovalRejected";

export const CAMPAIGN_CREATION_FINAL_APPROVE_CAMPAIGN_CMS =
  "campaignCreationFinalApproveCampaignCms";
export const CAMPAIGN_CREATION_GET_FINAL_APPROVAL_REQUEST_DETAILS_VENDOR_CMS =
  "campaignCreationGetFinalApprovalRequestDetailsVendorCms";
